<div class="w-full md:w-27rem px-3 md:px-0 mt-8 mx-auto flex gap-3 flex-column">
    <div class="flex flex-column gap-1">
        <label for="newPassword">Nowe hasło</label>
      <p-password
        styleClass="w-full"
        [(ngModel)]="newPassword"
        weakLabel="Niewystarczające hasło"
        mediumLabel="Niewystarczające hasło"
        strongLabel="Silne hasło"
        promptLabel="Hasło musi zawierać:"
        [toggleMask]="true">
        <ng-template pTemplate="header"> </ng-template>
        <ng-template pTemplate="footer">
          <ul class="pl-2 ml-2 mt-1" style="line-height: 1.5">
            <li>Przynajmniej jedna mała litera</li>
            <li>Przynajmniej jedna wielka litera</li>
            <li>Przynajmniej jedna cyfra</li>
            <li>Minimum 8 znaków</li>            
          </ul>
        </ng-template>
      </p-password>
     <em class="text-red-500 text-sm">{{errorMessage}}</em> 
    </div>
    <p-button class="mt-3" icon="pi pi-check" label="Zatwierdź" (onClick)="onSubmit()" data-clarity-unmask="true"></p-button>
  </div>